import type { ExcelColumnMapping } from './types';
import { formatDate } from '@/lib/formatUtils';

export const BANG_KE_HOA_DON_BAN_HANG_COLUMNS: ExcelColumnMapping[] = [
  { header: 'Đơn vị', resolver: row => row.ma_unit ?? row.unit_id ?? '' },
  { header: 'Ngày c/từ', resolver: row => formatDate(row.ngay_ct3) ?? '' },
  { header: 'Số c/từ', resolver: row => row.so_ct3 ?? '' },
  { header: 'Ngày xuất', resolver: row => formatDate(row.ngay_ct) ?? '' },
  { header: 'Số c/từ xuất', resolver: row => row.so_ct ?? '' },
  { header: 'Ngày hóa đơn', resolver: row => formatDate(row.ngay_ct0) ?? '' },
  { header: 'Số hóa đơn', resolver: row => row.so_ct0 ?? '' },
  { header: 'Mã khách hàng', resolver: row => row.ma_kh ?? '' },
  { header: 'Tên khách hàng', resolver: row => row.ten_kh ?? '' },
  { header: 'Diễn giải', resolver: row => row.dien_giai ?? '' },
  { header: 'Mã vật tư', resolver: row => row.ma_vt ?? '' },
  { header: 'Tên vật tư', resolver: row => row.ten_vt ?? '' },
  { header: 'Đvt', resolver: row => row.dvt ?? '' },
  { header: 'Số lượng', resolver: row => Number(row.sl_nhap_xuat ?? 0) },
  { header: 'SL bán KM', resolver: row => Number(row.sl_km ?? 0) },
  { header: 'Mã thuế', resolver: row => row.ma_thue ?? '' },
  { header: 'Giá bán', resolver: row => Number(row.gia2 ?? 0) },
  { header: 'Doanh thu', resolver: row => Number(row.tien2 ?? 0) },
  { header: 'Thuế', resolver: row => Number(row.thue ?? 0) },
  { header: 'Chiết khấu', resolver: row => Number(row.ck ?? 0) },
  {
    header: 'Doanh thu thuần',

    resolver: row => Number(row.tien2 ?? 0) - Number(row.ck ?? 0)
  },
  { header: 'Phải thu', resolver: row => Number(row.pt ?? 0) },
  { header: 'Giá vốn', resolver: row => Number(row.gia ?? 0) },
  { header: 'Tiền vốn', resolver: row => Number(row.tien_von ?? 0) },
  { header: 'Lợi nhuận gộp', resolver: row => Number(row.loi_nhuan ?? 0) },
  { header: '%LN/DT', resolver: row => Number(row.ln_dt ?? 0) },
  { header: '%LN/TV', resolver: row => Number(row.ln_tv ?? 0) },
  { header: 'Mã nv bán hàng', resolver: row => row.ma_nvbh ?? '' },
  { header: 'Tên nhân viên bán hàng', resolver: row => row.ten_nvbh ?? '' },
  { header: 'Mã kho', resolver: row => row.ma_kho ?? '' },
  { header: 'Tk vật tư', resolver: row => row.tk_vt ?? '' },
  { header: 'Tk doanh thu', resolver: row => row.tk_dt ?? '' },
  { header: 'Tk giá vốn', resolver: row => row.tk_gv ?? '' },
  { header: 'Bộ phận', resolver: row => row.ma_bp ?? '' },
  { header: 'Vụ việc', resolver: row => row.ma_vv ?? '' },
  { header: 'Hợp đồng', resolver: row => row.ma_hd ?? '' },
  { header: 'Đợt thanh toán', resolver: row => row.ma_dtt ?? '' },
  { header: 'Khế ước', resolver: row => row.ma_ku ?? '' },
  { header: 'Phí', resolver: row => row.ma_phi ?? '' },
  { header: 'Sản phẩm', resolver: row => row.ma_sp ?? '' },
  { header: 'Lệnh sản xuất', resolver: row => row.ma_lsx ?? '' },
  { header: 'C/p không h/lệ', resolver: row => row.ma_cp0 ?? '' },
  { header: 'Mã c/từ', resolver: row => row.ma_ct ?? '' }
];
